import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCustomerPriceListExcelThunk,
  fetchCustomerPriceListThunk,
} from "../thunks/customerPriceListThunks";

const initialState = {
  data: [],
  priceListExcel: [],
  loading: false,
  error: null,
};

const customerPriceListSlice = createSlice({
  name: "customerPriceList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerPriceListThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerPriceListThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload || [];
      })
      .addCase(fetchCustomerPriceListThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch price list";
      })
      .addCase(fetchCustomerPriceListExcelThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerPriceListExcelThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.priceListExcel = action.payload || [];
      })
      .addCase(fetchCustomerPriceListExcelThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch price list (Excel)";
      });
  },
});
export const {} = customerPriceListSlice.actions;
export default customerPriceListSlice.reducer;
